import template from './info-card.html';
export var InfoCardComponent = {
    template: template,
    bindings: {
        displayInfo: '<'
    },
    controller: /** @class */ (function () {
        function InfoCardComponent() {
            'ngInject';
        }
        InfoCardComponent.prototype.$onChanges = function (changes) {
            if (changes.displayInfo) {
                this.displayInfo = Object.assign({}, this.displayInfo);
            }
        };
        return InfoCardComponent;
    }())
};
//# sourceMappingURL=info-card.component.js.map